import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {AuthProvider} from "./context/AuthContext";
import {LoadingProvider} from "./context/LoadingContext";
import AuthorizationRoute from "./route/AuthorizationRoute";
import {ToastContainerCustom} from "@moeindal/base-raiko-panel-components";
import {RaikoUploadManagerProvider} from "./raikoComponents/raikoUploader/RaikoUploadManagerContext";


const root = ReactDOM.createRoot(
    document.getElementById(`root`)
);

root.render(
    <React.Fragment>
        <AuthProvider>
            <LoadingProvider>
                <BrowserRouter>
                    <AuthorizationRoute>
                        <RaikoUploadManagerProvider>
                            <App/>
                        </RaikoUploadManagerProvider>
                    </AuthorizationRoute>
                </BrowserRouter>
            </LoadingProvider>
        </AuthProvider>
        <ToastContainerCustom/>
    </React.Fragment>
)


